module.exports = __webpack_public_path__ + "img/neck-ecto-mesomorph-male.e5e16766.svg";